module.exports = __webpack_public_path__ + "img/lg_ring_r_i_1_null.f390ffbc.png";